/* IMPORTS
	You can import directly from node_modules here.
*/
import $ from 'jQuery';
// import 'what-input';
import '@accessible360/accessible-slick'; // Import Accessible Slick Slider

/*
	LIBRARY IMPORTS
	Utilities, plugins, and behaviors that aren't tied to a specific component.
*/
import anchorLinks from './libraries/anchor-links';
import linkContainer from './libraries/link-container';
import './libraries/hoverintent.min';
import './libraries/what-input';
import './libraries/browser-detect.min';


/*
	COMPONENT IMPORTS
	For specific components.
*/
import './components/cookies';
import './components/oembed';
import './components/header';
import browserDetect from './components/browser-detect';
import './components/menu--main';
import './components/menu--utility';
import './components/accordion-generic';
import './components/accessibility';
import externalLink from './components/external-link';

/*
	BLOCK IMPORTS
	For block-specific Javascript imports.
*/
import '../blocks/hero-homepage/js/hero-homepage';
import accordion from '../blocks/accordion-block/js/accordion-block';
import ticker from '../blocks/ticker/js/ticker';
import sponsorsCarousel from '../blocks/sponsors-carousel/js/sponsors-carousel';
import tabbedHighlightedContent from '../blocks/tabbed-highlighted-content/js/tabbed-highlighted-content';
import cardListDropdowns from '../blocks/card-list-with-dropdown/js/card-list-with-dropdown';
import filteredList from '../blocks/filtered-list/js/filtered-list';
import upcomingEvents from '../blocks/upcoming-events/js/upcoming-events';
import flexibleCardsCarousel from '../blocks/flexible-cards-carousel/js/flexible-cards-carousel';
import '../blocks/winner-awards-accordions/js/winner-awards-accordions';
import table from '../blocks/table/js/table';
import leadershipCards from '../blocks/leadership-cards/js/leadership-cards';
import sectionNav from '../blocks/section-nav/js/section-nav';
import bannerBlock from '../blocks/banner-block/js/banner-block';
import pageSidebarNavigation from '../blocks/page-sidebar-navigation/js/page-sidebar-navigation';
// import carousel from '../blocks/carousel/js/carousel';
// import tabset from '../blocks/tabset/js/tabset';

// Easy console access to jQuery through '$'
window.$ = $;

/* INITIALIZATION */
$(() => {
	$('body').addClass('document-ready');

	/* Higher priority first, lower priority later */
	browserDetect();
	anchorLinks();
	linkContainer();

	/* Lower Priority */
	externalLink();
	accordion();
	ticker();
	sponsorsCarousel();
	tabbedHighlightedContent();
	cardListDropdowns();
	filteredList();
	flexibleCardsCarousel();
	upcomingEvents();
	table();
	//leadershipCards();
	sectionNav();
	bannerBlock();
	pageSidebarNavigation();
});
